import { ShopCategoryType } from "../../../../balancing/types/BalancingCore";
export var checkIsBuildingDecoration = function (path) { return function (action, state$, dependencies) {
    var isBuildingDecoration = action.taskType &&
        action.taskType.shopCategory &&
        action.taskType.shopCategory === ShopCategoryType.Decorations;
    return isBuildingDecoration ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/checks/checkIsBuildingDecoration.ts
// module id = 2376
// module chunks = 3